import {
  Button,
  ButtonProps,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Typography,
} from "@mui/material";

type ModalProps = {
  open: boolean;
  title: string;
  bodyParagraphs: (string | React.ReactNode)[];
  buttons: {
    variant: ButtonProps["variant"];
    label: string;
    onClick: () => void;
    disabled?: boolean;
  }[];
  children?: React.ReactNode;
  footerContent?: React.ReactNode;
};

const Modal = ({
  open,
  title,
  bodyParagraphs,
  buttons,
  children,
  footerContent,
  ...rest
}: ModalProps & DialogProps) => {
  return (
    <Dialog open={open} PaperProps={{ sx: { padding: "22px 32px" } }} {...rest}>
      <DialogTitle fontWeight="bold" sx={{ textAlign: "center" }}>
        {title}
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          gap: 1,
        }}
      >
        {bodyParagraphs.map((paragraph, i) => (
          <Typography key={`modal-text${i}`} variant="body1">
            {paragraph}
          </Typography>
        ))}
        {children}
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
        }}
      >
        {buttons.map((button, i) => (
          <Button
            key={button.label + i}
            size={button.variant === "text" ? "medium" : "large"}
            variant={button.variant}
            onClick={button.onClick}
            disabled={button.disabled}
          >
            {button.label}
          </Button>
        ))}
      </DialogActions>
      <DialogContent>
        {footerContent}
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
